let text_wrapper = document.querySelector("[gsap-animation='text-wrapper']");
let text_1 = document.querySelector("[gsap-animation='text-1']");
let text_2 = document.querySelector("[gsap-animation='text-2']");
let text_3 = document.querySelector("[gsap-animation='text-3']");

let tl = gsap.timeline({
  repeat: -1,
  //repeatDelay: 1,
});

//Set text_2 & text_3 to display: block in webflow for this animation to work
function desktopAnimation() {
  tl.set(text_1, {
    xPercent: 0,
    yPercent: 0,
  });

  tl.to(text_1, {
    delay: 1,
    yPercent: -110,
    xPercent: 30,
    ease: "sine.inOut",
  });

  tl.to(
    text_wrapper,
    {
      width: "270px",
      ease: "sine.inOut",
    },
    "<"
  );

  tl.from(
    text_2,
    {
      yPercent: 100,
      xPercent: -50,
      display: "none",
      ease: "sine.inOut",
    },
    "<"
  );

  tl.to(text_2, {
    delay: 0.5,
    yPercent: -120,
    xPercent: 50,
    ease: "sine.inOut",
    //display: "none",
  });

  tl.from(
    text_3,
    {
      yPercent: 100,
      xPercent: -50,
      display: "none",
      ease: "sine.inOut",
    },
    "<"
  );

  tl.to(
    text_wrapper,
    {
      width: "220px",
      ease: "sine.inOut",
    },
    "<"
  );

  tl.to(text_3, {
    delay: 0.5,
    yPercent: -107,
    xPercent: -50,
    ease: "sine.inOut",
  });

  tl.to(
    text_wrapper,
    {
      width: "270px",
      ease: "sine.inOut",
    },
    "<"
  );

  tl.to(
    text_wrapper,
    {
      width: "270px",
      ease: "sine.inOut",
    },
    "<"
  );

  tl.fromTo(
    text_1,
    {
      yPercent: 100,
      xPercent: 50,
    },
    {
      yPercent: 0,
      xPercent: 0,
      ease: "sine.inOut",
    },
    "<"
  );
}

function mobileAnimation() {
  tl.set(text_1, {
    xPercent: 0,
    yPercent: 0,
  });

  tl.to(text_1, {
    delay: 1,
    yPercent: -110,
    xPercent: 30,
    ease: "sine.inOut",
  });

  tl.to(
    text_wrapper,
    {
      width: "210px",
      ease: "sine.inOut",
    },
    "<"
  );

  tl.from(
    text_2,
    {
      yPercent: 100,
      xPercent: -50,
      display: "none",
      ease: "sine.inOut",
    },
    "<"
  );

  tl.to(text_2, {
    delay: 0.5,
    yPercent: -100,
    xPercent: 50,
    ease: "sine.inOut",
    //display: "none",
  });

  tl.from(
    text_3,
    {
      yPercent: 100,
      xPercent: -50,
      display: "none",
      ease: "sine.inOut",
    },
    "<"
  );

  tl.to(
    text_wrapper,
    {
      width: "160px",
      ease: "sine.inOut",
    },
    "<"
  );

  tl.to(text_3, {
    delay: 0.5,
    yPercent: -107,
    xPercent: -50,
    ease: "sine.inOut",
  });

  tl.to(
    text_wrapper,
    {
      width: "200px",
      ease: "sine.inOut",
    },
    "<"
  );

  tl.to(
    text_wrapper,
    {
      width: "200px",
      ease: "sine.inOut",
    },
    "<"
  );

  tl.fromTo(
    text_1,
    {
      yPercent: 100,
      xPercent: 50,
    },
    {
      yPercent: 0,
      xPercent: 0,
      ease: "sine.inOut",
    },
    "<"
  );
}

if (window.matchMedia("(max-width: 768px)").matches) {
  mobileAnimation();
} else {
  desktopAnimation();
}
